import { TablePaginationProps, TableSortCellProps } from './types';

export const styleTableSortCell = (props: TableSortCellProps) => {
  const mc = 'TableSortCell';
  const cls = { main: [mc], inner: [`${mc}__Inner`], icon: [`${mc}__Icon`] };
  if (props.direction) {
    cls.main.push(`${mc}--${props.direction}`);
  }
  if (props.active) {
    cls.main.push(`${mc}--active`);
  }
  return cls;
};

export const styleTablePagination = (props: TablePaginationProps) => {
  const mc = 'TablePagination';
  const mcPagination = `${mc}__Pagination`;
  const mcPerPage = `${mc}__PerPage`;
  const cls = {
    main: [mc],
    actions: [mcPagination],
    perPage: [mcPerPage]
  };

  if (props.alignPagination) {
    cls.main.push(`${mc}--align-${props.alignPagination}`);
  }

  return cls;
};
